import script from "./NewsMessEN.vue?vue&type=script&setup=true&name=NewsMess&lang=js"
export * from "./NewsMessEN.vue?vue&type=script&setup=true&name=NewsMess&lang=js"

import "./NewsMessEN.vue?vue&type=style&index=0&id=3857a557&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3857a557"]])

export default __exports__